import React from "react";
import { Badge, Space, Tag, List, Button } from "antd";

import EssentialsStyled from "../../styles/Essentials";

const Essentials = () => {
  return (
    <EssentialsStyled>
      <div className="mainWrapper">
        <Tag className="tag" color="#02a2f2">
          ESSENTIALS
        </Tag>
        <h4 className="subHeading">A FEW CLICKS</h4>
        <h3 className="heading">Finish your LimeClicks installation</h3>
        <p className="description">
          This will enable LimeClicks to capture user behaviour data on your
          site.
        </p>
        <List.Item>
          <Space>
            <Badge count={1} style={{ backgroundColor: "#8d96a5" }} />
          </Space>{" "}
          <span>Enter site url</span>
        </List.Item>
        <List.Item>
          <Space>
            <Badge count={2} style={{ backgroundColor: "#8d96a5" }} />
          </Space>{" "}
          <span>Add Tracking Code</span>
        </List.Item>
        <Button type="primary">Install LimeClicks</Button>
      </div>
    </EssentialsStyled>
  );
};

export default Essentials;
